<script>
export default {
  props: {
    query: {
      type: Object,
      default () {
        return {}
      }
    },
    api: {
      type: String,
      default () {
        return '/web/api/artworks'
      }
    }
  },

  data () {
    return {
      artworks: [],
      pagination: {},
      loading: false,
    }
  },

  methods: {
    fetch (query) {
      this.$emit('loading')
      this.loading = true
      axios.get(this.api, { params: query })
        .then(({ data }) => {
          this.loading = false
          this.pagination = data.meta.pagination
          this.artworks = data.data
          this.$emit(this.state)
        })
    },
  },

  computed: {
    sharedData () {
      return {
        artworks: this.artworks,
        loading: this.loading,
        pagination: this.pagination,
        state: this.state,
      }
    },

    state () {
      if (this.loading) {
        return 'loading'
      }

      if (this.artworks.length > 0) {
        return 'loaded'
      }

      return 'empty'
    }
  },

  render () {
    return this.$scopedSlots.default({
      ...this.sharedData,

      // Method to maintain compatibility. We will have to change
      // implementation soon.
      sync (target, source) {
        Object.assign(target, source)
      },
    })
  },

  watch: {
    query: {
      deep: true,
      immediate: true,
      handler (query) {
        this.fetch(query)
      },
    },
  }
}
</script>
